import { Schema } from 'App/Actions/schema';

import { TireAction } from 'core/types/tire_action';

import usePaginationHandler from './usePaginationHandler';

export default function useTireActions(params: Schema) {
  return usePaginationHandler<TireAction>('tires/actions/log', params);
}
